import { Component } from '@angular/core';

@Component({
  selector: 'medrecord-auth-forgot-password-success',
  templateUrl: './forgot-password-success.component.html'
})
export class ForgotPasswordSuccessComponent {}
